import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f422a074"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_UploadComponent = _resolveComponent("UploadComponent")!
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    model: _ctx.formState,
    rules: _ctx.rules,
    "label-col": _ctx.labelCol,
    "wrapper-col": _ctx.wrapperCol
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        ref: "nickname",
        label: "昵称",
        name: "nickname"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.nickname,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.nickname) = $event))
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "mobile",
        label: "电话",
        name: "mobile"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.mobile,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.mobile) = $event)),
            type: "number",
            maxlength: 11
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "birthday",
        label: "出生日期",
        name: "birthday"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_date_picker, {
            value: _ctx.formState.birthday,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.birthday) = $event)),
            "value-format": "YYYY-MM-DD",
            style: {"width":"100%"}
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "avatar",
        label: "头像",
        name: "avatar"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.avatar,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.avatar) = $event)),
            style: {"display":"none"}
          }, null, 8, ["value"]),
          _createVNode(_component_a_form_item_rest, null, {
            default: _withCtx(() => [
              _createVNode(_component_UploadComponent, {
                "on-change": _ctx.onImageChange,
                "source-url": _ctx.formState.avatar
              }, null, 8, ["on-change", "source-url"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "remark",
        label: "备注",
        name: "remark"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_textarea, {
            value: _ctx.formState.remark,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.remark) = $event))
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, { "wrapper-col": { span: 24, offset: 6 } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            style: {"margin-left":"10px"},
            onClick: _ctx.resetForm
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules", "label-col", "wrapper-col"]))
}